import context from "../context";

export const BuildUri = (path: string, replacementParams = {}, queryParams = {}): string => {
    let uri = context.uriPrefix + path;
    Object.keys(replacementParams)
            .forEach(key =>
                uri = uri.replace(new RegExp("{" + key + "}", "g"), replacementParams[key])
            );
    if (queryParams && Object.keys(queryParams).length > 0) {
        uri += "?1=1";
        Object.keys(queryParams)
            .filter(key => queryParams[key] !== undefined)
            .forEach(key =>
                uri = uri   + "&" + encodeURIComponent(key)
                            + "=" + encodeURIComponent(queryParams[key])
            );
    }
    return uri;
};